module.exports = __webpack_public_path__ + "img/01.a09f8eb8.jpg";